module.exports = __webpack_public_path__ + "static/media/logo.349ab2b0.png";